module.exports = __webpack_public_path__ + "static/media/grin-hearts.65cc11ca.svg";